import { render, staticRenderFns } from "./backc-manage.vue?vue&type=template&id=68ea9a28"
import script from "./backc-manage.vue?vue&type=script&lang=ts"
export * from "./backc-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports